import React from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import Box from './Box';
import Circle from '@components/Circle';

class TooltipActivator extends React.Component {
  render() {
    return (
      <Box position="absolute" bottom="100%" mb="6px" ml={1}>
        <Circle
          size="13px"
          lineHeight="10px"
          style={{ borderWidth: '1px' }}
          fontSize="10px"
        >
          ?
        </Circle>
      </Box>
    );
  }
}

class TooltipContent extends React.PureComponent {
  render() {
    const { children, noWrap, position } = this.props;

    const positionProps =
      position === 'top'
        ? {
            bottom: '0px',
            mb: 5,
            ml: 1
          }
        : {
            top: '0px',
            ml: 1
          };

    return (
      <Box
        bg="grayscale.black"
        color="grayscale.white"
        p={1}
        borderRadius="4px"
        position="absolute"
        left="100%"
        zIndex="2"
        style={noWrap ? { whiteSpace: 'nowrap' } : {}}
        {...positionProps}
      >
        {children}
      </Box>
    );
  }
}

export default class Tooltip extends React.PureComponent {
  state = { showTooltip: false };

  toggleTooltip = e => {
    e.stopPropagation();
    this.setState(({ showTooltip }) => ({ showTooltip: !showTooltip }));
  };

  render() {
    const { content, children, noWrap, position = 'bottom', useActivator } = this.props;
    const { showTooltip } = this.state;

    return (
      <OutsideClickHandler onOutsideClick={() => this.setState({ showTooltip: false })}>
        <Box
          as="button"
          bg="transparent"
          border="none"
          p={0}
          onClick={this.toggleTooltip}
        >
          {useActivator ? <TooltipActivator /> : children}
          {showTooltip && content && (
            <TooltipContent noWrap={noWrap} position={position}>
              {content}
            </TooltipContent>
          )}
        </Box>
      </OutsideClickHandler>
    );
  }
}
